/* eslint-disable react/prop-types */
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { DOMId } from '@editor/src/page/index/components/canvas/canvas-constants';
import { IRect } from '@src/slide/infrastructure/module/independent/graphic/rect/rect';

interface IMultiSelectedDashOuterProps extends IRect {
    scale: number;
    scrollT: number;
    scrollL: number;
}

interface IMultiSelectedDashOuterState {
    isShown: boolean;
    config: IRect;
}

export interface IMultiSelectedDashOuterMenu {
    show: (rect: IRect) => void;
    hide: () => void;
    isShown: () => boolean;
}

/**
 * 目前的主要职责是渲染多选时的虚线框
 */
export default class MultiSelectedDashOuter
    extends Component<IMultiSelectedDashOuterProps, IMultiSelectedDashOuterState> {
    /**
     * 创建一个渲染虚线框的实例，通过闭包的方式保存实例
     *
     * @param config  配置项
     * @returns {{show: show, hide: hide, isShown: isShown}}
     */
    public static createMenu(config: IRect): IMultiSelectedDashOuterMenu {
        const div = document.getElementById(DOMId.MULTI_SELECTED_DASH_OUTER);
        const translatesNum = document.defaultView?.getComputedStyle(div!).transform;
        const translates = parseFloat(translatesNum!.substring(7)
            .split(',')[0]);
        const canvas = document.getElementById(DOMId.CANVAS);
        // @ts-ignore
        const scrollTop = canvas?.scrollTop || canvas?.pageYOffset || canvas?.scrollTop;
        // @ts-ignore
        const scrollLeft = canvas?.scrollLeft || canvas?.pageXOffset || canvas?.scrollLeft;

        let currentConfig = {
            ...config,
            scrollT: scrollTop,
            scrollL: scrollLeft,
            scale: translates,
        };
        // @ts-ignore
        const toolbarInstance = ReactDOM.render(
            <MultiSelectedDashOuter {...currentConfig}/>,
            div,
        ) as MultiSelectedDashOuter;


        function show(newConfig) {
            currentConfig = {
                ...newConfig,
                scrollT: scrollTop,
                scrollL: scrollLeft,
                scale: translates,
            };

            if (toolbarInstance) {
                toolbarInstance.showToolbar(currentConfig);
            }
        }

        function hide() {
            if (toolbarInstance) {
                return toolbarInstance.hideMenu();
            }
        }

        function isShown(): boolean {
            if (toolbarInstance) {
                return toolbarInstance.isShown();
            }
            return false;
        }

        return { show, isShown, hide };
    }

    public constructor(props, context) {
        super(props, context);
        this.state = {
            isShown: false,
            config: {
                left: this.props.left,
                top: this.props.top,
                width: this.props.width,
                height: this.props.height,
            },
        };
    }

    public showToolbar = (newConfig) => {
        if (!this.state.isShown) {
            this.setState({
                isShown: true,
                config: newConfig,
            });
        } else {
            this.setState({
                config: newConfig,
            });
        }
    };

    public hideMenu = () => {
        if (this.state.isShown) {
            this.setState({
                isShown: false,
            });
        }
    };

    public isShown = () => this.state.isShown;

    public handleContextMenu = () => {
        this.hideMenu();
    };

    public componentDidMount() {
        const config = { ...this.props };
        this.setState({
            config,
        });
    }


    public render() {
        const { scale } = this.props;
        const scrollTop = this.props.scrollT;
        const scrollLeft = this.props.scrollL;
        const display = this.state.isShown ? 'block' : 'none';
        const { config } = this.state;

        return (
            <React.Fragment
            >
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    version="1.1"
                    style={{
                        left: 0,
                        top: 0,
                        width: config.width > 1 ? Math.ceil(config.width) : 1,
                        height: config.height > 1 ? Math.ceil(config.height) : 1,
                        position: 'absolute',
                        overflow: 'visible',
                        display,

                    }}
                    pointerEvents={'none'}>
                    <rect
                        style={{
                            display,
                        }}
                        x={Math.ceil(config.left - 5 - (scrollLeft / scale)) - 0.5}
                        y={Math.ceil(config.top - 5 - (scrollTop / scale)) - 0.5}
                        width={Math.ceil(config.width + 10) + 1}
                        height={Math.ceil(config.height + 10) + 1}
                        stroke={'#ffffff'}
                        strokeOpacity={0.32}
                        strokeWidth={1}
                        fillOpacity={0}
                        strokeDasharray={2}
                        pointerEvents={'stroke'}
                    />
                    <rect
                        style={{
                            display,
                        }}
                        x={Math.ceil(config.left - 5 - (scrollLeft / scale)) + 0.5}
                        y={Math.ceil(config.top - 5 - (scrollTop / scale)) + 0.5}
                        width={Math.ceil(config.width + 10) - 1}
                        height={Math.ceil(config.height + 10) - 1}
                        stroke={'#000000'}
                        strokeOpacity={0.32}
                        strokeWidth={1}
                        fillOpacity={0}
                        strokeDasharray={2}
                        pointerEvents={'stroke'}
                    />
                </svg>
            </React.Fragment>
        );
    }
}
